module.exports = __webpack_public_path__ + "img/partner12.50b1ace4.jpg";